<template>
  <span class="text-highlighted">
    <span
      v-for="(word, i) in textWords"
      :key="i"
      :class="{ highlight: i === 1 }"
      >{{ word }}</span
    >
  </span>
</template>

<script>
import { normalizeString } from "@/utils/StringUtils";

export default {
  name: "TextHighlighted",
  props: {
    text: {
      type: String,
      required: null
    },
    search: {
      type: String,
      default: null
    }
  },
  computed: {
    normalizedQuery: function() {
      return normalizeString(this.search);
    },
    textWords() {
      const text = normalizeString(this.text);
      const search = normalizeString(this.search);

      const startIndex = text.indexOf(search);
      const endIndex = startIndex + search.length;

      if (startIndex < 0) {
        return [this.text];
      } else {
        return [
          this.text.substring(0, startIndex),
          this.text.substring(startIndex, endIndex),
          this.text.substring(endIndex, this.text.length)
        ];
      }
    }
  }
};
</script>

<style scoped>
.highlight {
  background-color: lightpink;
}
</style>
